<!-- frontend/src/components/Footer.vue -->
<template>
  <footer class="modern-footer">
    <div class="footer-content">
      <!-- Copyright Section -->
      <div class="footer-section copyright-section">
        <p class="copyright-text">
          © {{ currentYear }} <span class="brand-name">WordCloudStudio</span>
        </p>
        <p class="tagline">Creating Beautiful Word Art</p>
      </div>

      <!-- Social Links -->
      <div class="footer-section">
        <h3 class="section-title">Community</h3>
        <div class="footer-links">
          <a href="https://www.reddit.com/r/iosapps/comments/1g7sxb6/wordcloudstudio_will_support_previewing_fonts_on/" target="_blank" class="footer-link">
            <span>Reddit</span>
          </a>
          <a href="https://zhuanlan.zhihu.com/p/5017165864" target="_blank" class="footer-link">
            <span>ZhiHu</span>
          </a>
          <a href="https://www.producthunt.com/products/wordcloudstudio" target="_blank" class="footer-link">
            <span>ProductHunt</span>
          </a>
          <a href="https://www.tiktok.com/@emperinter/video/7393754097486138641?is_from_webapp=1&sender_device=pc&web_id=7277449136130885122" target="_blank" class="footer-link">
            <span>TikTok</span>
          </a>
          <a href="https://www.youtube.com/shorts/HJSuW7ViCrQ" target="_blank" class="footer-link">
            <span>Youtube</span>
          </a>
          <a href="https://news.ycombinator.com/item?id=40837275" target="_blank" class="footer-link">
            <span>Hacker News</span>
          </a>
          <a href='/sitemap.xml' target="_blank" class="footer-link">
            <span>SiteMap</span>
          </a>
        </div>
      </div>

      <!-- Related Projects -->
      <div class="footer-section">
        <h3 class="section-title">Our Projects</h3>
        <div class="footer-links projects-links">
          <a href="https://chartstudio.top/" target="_blank" class="footer-link">chartstudio</a>
          <a href="https://wordart.top/" target="_blank" class="footer-link">wordart</a>
          <a href="https://wordcloudmaster.com/" target="_blank" class="footer-link">wordcloudmaster</a>
          <a href="https://wordcloud.top/" target="_blank" class="footer-link">wordcloud</a>
          <a href="https://sankeymaster.com/" target="_blank" class="footer-link">sankeymaster</a>
          <a href="https://piechartmaster.com/" target="_blank" class="footer-link">piechartmaster</a>
          <a href="https://pasteymaster.com/" target="_blank" class="footer-link">pasteymaster</a>
          <a href="https://pandaremit.top/" target="_blank" class="footer-link">pandaremit</a>
          <a href="https://emperinter.cn/" target="_blank" class="footer-link">emperinter</a>
          <a href="https://www.emperinter.info/" target="_blank" class="footer-link">blog</a>
        </div>
      </div>
    </div>
  </footer>
  <Modal ref="modal">
    <template v-slot:default>
      <h2>👉 <a href='https://apps.apple.com/us/app/wordcloudstudio-wordart-tool/id6504160406' target='_blank'>WordCloudStudio - WordArt Tool !</a>👈</h2>
      <p><a href='https://apps.apple.com/us/app/wordcloudstudio-wordart-tool/id6504160406' target='_blank'>Create stunning word cloud / word art / text art effortlessly. Ideal for marketers, educators, data enthusiasts, creatives, business pros, event planners, and more !</a></p>
    </template>
  </Modal>  
</template>

<script>
 /* eslint-disable */ 
import Modal from '@/components/Modal.vue'; // 引入 Modal 组件

export default {
  name: 'Footer',
  components: {
    Modal, // 注册 Modal 组件
  },
  data() {
    return {
      currentYear: new Date().getFullYear(), // Get the current year
    };
  }
};
</script>

<style scoped>
.modern-footer {
  margin-top: var(--spacing-3xl);
  padding: var(--spacing-3xl) var(--spacing-lg);
  background: rgba(15, 15, 35, 0.8);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-content {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  gap: var(--spacing-3xl);
}

.footer-section {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

.copyright-section {
  justify-content: center;
}

.copyright-text {
  font-size: var(--font-size-base);
  color: var(--text-secondary);
  margin: 0;
}

.brand-name {
  background: var(--primary-gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 700;
}

.tagline {
  font-size: var(--font-size-sm);
  color: var(--text-muted);
  font-style: italic;
  margin: 0;
}

.section-title {
  font-size: var(--font-size-lg);
  font-weight: 700;
  background: var(--primary-gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 var(--spacing-sm) 0;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-sm);
}

.footer-link {
  display: inline-flex;
  align-items: center;
  padding: var(--spacing-xs) var(--spacing-md);
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--radius-full);
  color: var(--text-secondary);
  text-decoration: none;
  font-size: var(--font-size-sm);
  transition: all var(--transition-base);
}

.footer-link:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(102, 126, 234, 0.5);
  color: var(--primary-color);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.projects-links {
  max-width: 100%;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .footer-content {
    grid-template-columns: 1fr 1fr;
  }

  .copyright-section {
    grid-column: 1 / -1;
    text-align: center;
  }
}

@media (max-width: 768px) {
  .modern-footer {
    padding: var(--spacing-2xl) var(--spacing-md);
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: var(--spacing-2xl);
  }

  .footer-section {
    text-align: center;
    align-items: center;
  }

  .footer-links {
    justify-content: center;
  }

  .copyright-section {
    grid-column: 1;
  }
}

@media (max-width: 480px) {
  .modern-footer {
    padding: var(--spacing-xl) var(--spacing-sm);
  }

  .footer-content {
    gap: var(--spacing-xl);
  }

  .footer-link {
    font-size: var(--font-size-xs);
    padding: var(--spacing-xs) var(--spacing-sm);
  }
}
</style>